(function () {
  var checkoutEnabled = true;
  var multiplierMap = {
    3: 1,
    6: 1.14457125,
    12: 1.2786225,
    24: 1.574085,
  };

  function formatCRC(value) {
    return "¢" + Math.round(value).toLocaleString("es-CR").replace(/,/g, ".");
  }

  function parseCRC(value) {
    var parsed = parseInt(
      String(value || "")
        .replace(/[¢.]/g, "")
        .replace(/\s/g, ""),
      10,
    );
    return isNaN(parsed) ? NaN : parsed;
  }

  function getMinimumPrima(productPrice) {
    return 1;
  }

  function getDefaultPrima(productPrice) {
    return Math.round(productPrice * 0.2);
  }

  function calculateFinancing(productPrice, prima, months) {
    var saldo = Math.max(productPrice - prima, 0);
    var mensualidad = (saldo * multiplierMap[months]) / months;
    var total = mensualidad * months;

    return {
      saldo: saldo,
      mensualidad: mensualidad,
      total: total,
    };
  }

  function getThemeString(group, key, fallback) {
    return window.AlilaoThemeStrings &&
      window.AlilaoThemeStrings[group] &&
      window.AlilaoThemeStrings[group][key]
      ? window.AlilaoThemeStrings[group][key]
      : fallback;
  }

  function pauseGalleryMedia(scope) {
    var videos = scope.querySelectorAll(".product-gallery__panel video");
    var index;

    for (index = 0; index < videos.length; index += 1) {
      videos[index].pause();
    }
  }

  /* ---- Add-to-cart popup ---- */
  function showAddedPopup() {
    var overlay = document.createElement("div");
    overlay.className = "cart-added-overlay";
    overlay.innerHTML =
      '<div class="cart-added-popup">' +
      '<div class="cart-added-popup__icon">' +
      '<svg xmlns="http://www.w3.org/2000/svg" width="150" height="150" viewBox="0 0 150 150" fill="none">' +
      '<path d="M31.25 87.5L53.125 109.375L118.75 40.625" stroke="#141B34" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>' +
      "</svg>" +
      "</div>" +
      '<p class="cart-added-popup__text">' +
      getThemeString("product", "addedToCart", "Added to cart") +
      "</p>" +
      "</div>";

    document.body.appendChild(overlay);

    setTimeout(function () {
      overlay.classList.add("is-leaving");
      setTimeout(function () {
        if (overlay.parentNode) {
          overlay.parentNode.removeChild(overlay);
        }
      }, 300);
    }, 2000);
  }

  function interceptAddToCart() {
    var form = document.getElementById("addToCartForm");
    if (!form) return;

    form.addEventListener(
      "submit",
      function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();

        var formData = new FormData(form);
        var xhr = new XMLHttpRequest();
        xhr.open("POST", "/cart/add.js", true);
        xhr.setRequestHeader("Accept", "application/json");
        xhr.onload = function () {
          if (xhr.status === 200) {
            showAddedPopup();
            /* Update cart count in header */
            var countEl = document.querySelector(".cart-count");
            if (countEl) {
              try {
                var item = JSON.parse(xhr.responseText);
                var currentCount = parseInt(countEl.textContent, 10) || 0;
                var addedQty = item.quantity || 1;
                countEl.textContent = currentCount + addedQty;
                countEl.classList.remove("hidden-count");
              } catch (e) {
                /* ignore */
              }
            }
          }
        };
        xhr.send(formData);
      },
      true,
    );
  }

  function setCheckoutLinkState(link, href, disabled) {
    if (!link) {
      return;
    }

    link.classList.toggle("is-disabled", disabled);
    link.classList.toggle("is-checkout-disabled", disabled);
    link.setAttribute("aria-disabled", disabled ? "true" : "false");

    if (disabled) {
      link.removeAttribute("href");
      link.setAttribute("tabindex", "-1");
      return;
    }

    link.setAttribute("href", href);
    link.removeAttribute("tabindex");
  }

  function ProductPage(section) {
    this.section = section;
    this.sectionId = section.getAttribute("data-section-id");
    this.productJsonNode = document.getElementById(
      "ProductJson-" + this.sectionId,
    );

    if (!this.productJsonNode) {
      return;
    }

    this.product = JSON.parse(this.productJsonNode.textContent);
    this.variantSelect = section.querySelector(
      "#productSelect-" + this.sectionId,
    );
    this.quantityInput = section.querySelector("#quantity-" + this.sectionId);
    this.quantityValue = section.querySelector("[data-quantity-value]");
    this.buyNowLink = section.querySelector("[data-buy-now-link]");
    this.addToCartButton = section.querySelector("#addToCart");
    this.skuValue = section.querySelector(".product-info__sku-value");
    this.priceCurrent = section.querySelector("#product-page-price-current");
    this.priceCompare = section.querySelector("#product-page-price-compare");
    this.priceBadge = section.querySelector("#product-page-price-badge");
    this.priceBadgeValue = section.querySelector("[data-price-badge-value]");
    this.galleryThumbs = section.querySelectorAll(".product-gallery__thumb");
    this.galleryPanels = section.querySelectorAll(".product-gallery__panel");
    this.primaInput = section.querySelector("[data-prima-input]");
    this.primaField = this.primaInput
      ? this.primaInput.closest(".financing-calculator__field")
      : null;
    this.termButtons = section.querySelectorAll("[data-term]");
    this.paymentAmount = section.querySelector("[data-financing-payment]");
    this.primaAmount = section.querySelector("[data-financing-prima-total]");
    this.balanceAmount = section.querySelector(
      "[data-financing-balance-total]",
    );
    this.totalAmount = section.querySelector("[data-financing-total]");
    this.selectedMonths = 3;

    this.init();
  }

  ProductPage.prototype.init = function () {
    var self = this;

    if (this.variantSelect) {
      this.variantSelect.addEventListener("change", function () {
        self.updateVariant();
      });
    }

    this.section.addEventListener("click", function (event) {
      var quantityButton = event.target.closest("[data-quantity-action]");
      var thumbButton = event.target.closest(".product-gallery__thumb");
      var termButton = event.target.closest("[data-term]");

      if (quantityButton) {
        self.updateQuantity(
          quantityButton.getAttribute("data-quantity-action"),
        );
      }

      if (thumbButton) {
        self.setActiveMedia(thumbButton.getAttribute("data-media-id"));
      }

      if (termButton) {
        self.selectedMonths = parseInt(
          termButton.getAttribute("data-term"),
          10,
        );
        self.updateTermState();
        self.updateFinancing();
      }
    });

    if (this.primaInput) {
      if (this.primaField) {
        this.primaField.addEventListener("click", function (event) {
          if (event.target !== self.primaInput) {
            self.primaInput.focus();
          }
        });
      }

      this.primaInput.addEventListener("input", function () {
        var variant = self.getSelectedVariant();
        var productPrice = variant ? variant.price / 100 : 0;
        var min = 1;
        var max = productPrice;
        var raw = parseCRC(self.primaInput.value);

        if (!isNaN(raw) && raw >= min && raw <= max) {
          self.updateFinancing(raw);
        }
      });

      this.primaInput.addEventListener("keydown", function (event) {
        if (event.key === "Enter") {
          event.preventDefault();
          self.commitPrimaInput();
          self.primaInput.blur();
        }
      });

      this.primaInput.addEventListener("blur", function () {
        self.commitPrimaInput();
      });
    }

    if (this.buyNowLink) {
      this.buyNowLink.addEventListener("click", function (event) {
        if (self.buyNowLink.classList.contains("is-disabled")) {
          event.preventDefault();
        }
      });
    }

    this.updateVariant();
    this.updateQuantity();
  };

  ProductPage.prototype.commitPrimaInput = function () {
    var variant;
    var productPrice;
    var raw;
    var min = 1;
    var max;
    var prima;

    if (!this.primaInput) {
      return;
    }

    variant = this.getSelectedVariant();
    productPrice = variant ? variant.price / 100 : 0;
    raw = parseCRC(this.primaInput.value);
    max = productPrice;

    if (isNaN(raw) || raw < min) {
      prima = min;
    } else if (raw > max) {
      prima = max;
    } else {
      prima = raw;
    }

    this.primaInput.value = formatCRC(prima);
    this.updateFinancing(prima);
  };

  ProductPage.prototype.getSelectedVariant = function () {
    var selectedId = this.variantSelect ? String(this.variantSelect.value) : "";
    var variants =
      this.product && this.product.variants ? this.product.variants : [];
    var index;

    for (index = 0; index < variants.length; index += 1) {
      if (String(variants[index].id) === selectedId) {
        return variants[index];
      }
    }

    return variants.length ? variants[0] : null;
  };

  ProductPage.prototype.getSelectedQuantity = function () {
    return Math.max(parseInt(this.quantityInput.value, 10) || 1, 1);
  };

  ProductPage.prototype.updateQuantity = function (direction) {
    var quantity = this.getSelectedQuantity();

    if (direction === "increase") {
      quantity += 1;
    } else if (direction === "decrease") {
      quantity = Math.max(quantity - 1, 1);
    }

    this.quantityInput.value = quantity;

    if (this.quantityValue) {
      this.quantityValue.textContent = quantity;
    }

    this.updateBuyNowLink();
  };

  ProductPage.prototype.updateVariant = function () {
    var variant = this.getSelectedVariant();
    var comparePrice;
    var salePrice;
    var discount;
    var mediaId;

    if (!variant) {
      return;
    }

    salePrice = variant.price / 100;
    comparePrice = variant.compare_at_price
      ? variant.compare_at_price / 100
      : 0;
    discount =
      comparePrice > salePrice
        ? Math.round((1 - salePrice / comparePrice) * 100)
        : 0;
    mediaId =
      variant.featured_media && variant.featured_media.id
        ? variant.featured_media.id
        : variant.featured_image && variant.featured_image.id
          ? variant.featured_image.id
          : "";

    if (this.skuValue) {
      this.skuValue.textContent =
        variant.sku || getThemeString("product", "skuUnavailable", "N/A");
    }

    if (this.priceCurrent) {
      this.priceCurrent.textContent = formatCRC(salePrice);
    }

    if (this.priceCompare) {
      if (comparePrice > salePrice) {
        this.priceCompare.textContent = formatCRC(comparePrice);
        this.priceCompare.classList.remove("is-hidden");
      } else {
        this.priceCompare.textContent = "";
        this.priceCompare.classList.add("is-hidden");
      }
    }

    if (this.priceBadge) {
      if (discount > 0) {
        if (this.priceBadgeValue) {
          this.priceBadgeValue.textContent = "-" + discount + "%";
        }
        this.priceBadge.classList.remove("is-hidden");
      } else {
        if (this.priceBadgeValue) {
          this.priceBadgeValue.textContent = "";
        }
        this.priceBadge.classList.add("is-hidden");
      }
    }

    if (this.addToCartButton) {
      this.addToCartButton.disabled = !variant.available;
      this.addToCartButton.setAttribute("data-variant-id", variant.id);
    }

    if (this.buyNowLink) {
      this.buyNowLink.setAttribute("data-variant-id", variant.id);
    }

    if (mediaId) {
      this.setActiveMedia(String(mediaId));
    }

    if (this.primaInput) {
      this.primaInput.value = formatCRC(getDefaultPrima(salePrice));
    }

    this.updateBuyNowLink();
    this.updateFinancing();
  };

  ProductPage.prototype.updateBuyNowLink = function () {
    var variant = this.getSelectedVariant();
    var quantity = this.getSelectedQuantity();
    var href;
    var isDisabled;

    if (!variant || !this.buyNowLink) {
      return;
    }

    href =
      "/cart/" + variant.id + ":" + quantity + "?attributes[source]=whatsapp";
    isDisabled = !variant.available || !checkoutEnabled;

    setCheckoutLinkState(this.buyNowLink, href, isDisabled);
  };

  ProductPage.prototype.updateTermState = function () {
    var index;

    for (index = 0; index < this.termButtons.length; index += 1) {
      var button = this.termButtons[index];
      var isActive =
        parseInt(button.getAttribute("data-term"), 10) === this.selectedMonths;
      button.classList.toggle("is-active", isActive);
      button.setAttribute("aria-selected", isActive ? "true" : "false");
    }
  };

  ProductPage.prototype.updateFinancing = function (primaValue) {
    var variant = this.getSelectedVariant();
    var productPrice;
    var prima;
    var result;

    if (
      !variant ||
      !this.primaInput ||
      !this.paymentAmount ||
      !this.primaAmount ||
      !this.balanceAmount ||
      !this.totalAmount
    ) {
      return;
    }

    productPrice = variant.price / 100;
    prima =
      typeof primaValue === "number" && !isNaN(primaValue)
        ? primaValue
        : parseCRC(this.primaInput.value);

    if (isNaN(prima)) {
      prima = getDefaultPrima(productPrice);
    }

    result = calculateFinancing(productPrice, prima, this.selectedMonths);

    this.paymentAmount.textContent = formatCRC(result.mensualidad);
    this.primaAmount.textContent = formatCRC(prima);
    this.balanceAmount.textContent = formatCRC(result.total);
    this.totalAmount.textContent = formatCRC(prima + result.total);
  };

  ProductPage.prototype.setActiveMedia = function (mediaId) {
    var index;

    pauseGalleryMedia(this.section);

    for (index = 0; index < this.galleryPanels.length; index += 1) {
      this.galleryPanels[index].classList.toggle(
        "is-active",
        this.galleryPanels[index].getAttribute("data-media-id") ===
          String(mediaId),
      );
    }

    for (index = 0; index < this.galleryThumbs.length; index += 1) {
      this.galleryThumbs[index].classList.toggle(
        "active",
        this.galleryThumbs[index].getAttribute("data-media-id") ===
          String(mediaId),
      );
    }
  };

  function initProductPages(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var sections = scope.querySelectorAll(".alilao-product-page-section");
    var index;

    for (index = 0; index < sections.length; index += 1) {
      if (
        sections[index].getAttribute("data-alilao-product-page-ready") ===
        "true"
      ) {
        continue;
      }

      sections[index].setAttribute("data-alilao-product-page-ready", "true");
      new ProductPage(sections[index]);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      interceptAddToCart();
      initProductPages(document);
    });
  } else {
    interceptAddToCart();
    initProductPages(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    if (event.target) {
      initProductPages(event.target);
    }
  });
})();
